module.exports = __webpack_public_path__ + "img/11.f7194600.png";